type NavigatingRouter = {
    navigate(to: string): Promise<void>;
    state: {navigation: {location?: {pathname: string}}};
};

let browserRouter: NavigatingRouter | undefined;

export const setRouter = (router: NavigatingRouter): void => {
    browserRouter = router;
};

export const redirectTo = (url: string): void => {
    void browserRouter?.navigate(url);
};

/** Whether a navigation to the path is underway (the router updates its state as soon as `navigate` is called). */
export const isNavigatingTo = (pathname: string): boolean =>
    pathname === browserRouter?.state.navigation.location?.pathname;
